export const productFiltersApiToFormMap = {
  departments: 'filters.product.departments',
  sub_departments: 'filters.product.subDepartments',
  collection_types: 'filters.product.collectionTypes',
  seasons: 'filters.product.seasons',
  events: 'filters.product.events',
  brands: 'filters.product.brands',
  manufacturers: 'filters.product.manufacturers',
  classes: 'filters.product.classes',
  sub_classes: 'filters.product.subClasses',
} as const;

export const locationFiltersApiToFormMap = {
  regions: 'filters.geographic.regions',
  countries: 'filters.geographic.countries',
  locations: 'filters.geographic.locations',
  location_types: 'filters.geographic.locationTypes',
} as const;

export const productGroupsFiltersApiToFormMap = {
  groups: 'filters.product.productGroups',
} as const;

export const locationClustersFiltersApiToFormMap = {
  location_clusters: 'filters.locationClusters',
} as const;
